import _compact from 'lodash/compact';
import { logOut } from '@common/contexts/session';

import logException from '@util/js-error';
import globalActions from '@actions';

const createErrorHandler = () => error => {
  if (error && error.message === 'Not Authenticated') {
    logOut();
  }

  throw error;
};

const mapListeners = (allListeners, newListeners) =>
  Object.keys(newListeners).reduce((acc, key) => {
    const arr = acc[key] ? [...acc[key], newListeners[key]] : [newListeners[key]];
    return { ...acc, [key]: arr };
  }, allListeners);

export default class Fetchable {
  constructor(API) {
    this.API = API;
    this.listeners = {};
  }

  addListeners(...groupsListeners) {
    this.listeners = groupsListeners
      .map(listeners => listeners(this.API))
      .reduce((acc, listeners) => mapListeners(acc, listeners), this.listeners);
  }

  get middleware() {
    return store => {
      const loggedOutErrorHandler = createErrorHandler(store);
      this.API.onError = loggedOutErrorHandler;
      return next => async action => {
        if (this.listeners[action.type]) {
          next(action);

          try {
            const newActions = await Promise.all(
              this.listeners[action.type].map(listener => {
                store.dispatch(globalActions.ADD_FETCH({ data: action }));
                return listener(action, store);
              })
            );
            return Promise.all(
              _compact(newActions).map(newAction => {
                store.dispatch(globalActions.REMOVE_FETCH({ data: action }));
                return store.dispatch(newAction);
              })
            );
          } catch (error) {
            if (error && error.data) {
              store.dispatch(globalActions.FETCH_RESOURCE_FAIL({ error }));
            } else if (error && error.message === 'Not Authenticated') {
              /**
               * User has been logged out. No need to report errors to sentry.
               * Additionally, we don't want to forward any actions to the
               * awaiting fetchables.
               *
               * This block intentionally left blank.
               */
            } else {
              logException(error, action);
            }
          }
        }

        return next(action);
      };
    };
  }
}
